(function ($) {

  // Selector Picker
  var selectorPicker = {
    url: 'https://s3.amazonaws.com/shopify-apps/Plugins/SelectorPicker/selector-picker.js',
    cmd: 'sign=wholesale-pricing-membership-manager'
  };
  // do nothing for not-logged customer
  if (typeof SWPMMParams == 'undefined' && document.location.search.indexOf(selectorPicker.cmd) === -1) {
    return;
  }

  var Shopify = Shopify || {};

  var formatMoney = function(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    var value = '';

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }

    if (formatString.indexOf('with_comma_separator') !== -1) {
      return formatString.replace(placeholderRegex, value).replace(',00', '');
    } else {
      return formatString.replace(placeholderRegex, value).replace('.00', '');
    }
  }

  Shopify.formatMoney = formatMoney;

  /**
   * Return:
   *  0   - version1 = version2
   *  -1  - version1 < version2
   *  1   - version1 > version2
   */
  var versionCompare = function (version1, version2) {
    function normalize (version) {
      return jQuery.map(version.split('.'), function (value) {
        return parseInt(value, 10);
      });
    }

    version2 = version2 || $.fn.jquery;
    if (version1 == version2) {
      return 0;
    }
    var v1 = normalize(version1);
    var v2 = normalize(version2);
    var len = Math.max(v1.length, v2.length);
    for (var i = 0; i < len; i++) {
      v1[i] = v1[i] || 0;
      v2[i] = v2[i] || 0;
      if (v1[i] == v2[i]) {
        continue;
      }
      return v1[i] > v2[i] ? 1 : -1;
    }
    return 0;
  };

  var loadScript = function (url, callback) {
    loadAsset('script', 'text/javascript', url, callback);
  };

  var loadAsset = function (elementName, type, url, callback) {

    var script = document.createElement(elementName);
    if (elementName == 'script') {
      script.src = url;
    } else if (type == 'text/css') {
      script.rel = 'stylesheet';
      script.media = 'all';
      script.href = url;
    }

    script.type = type;

    // If the browser is Internet Explorer.
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
      // For any other browser.
    } else {
      script.onload = function () {
        callback();
      };
    }

    document.getElementsByTagName('head')[0].appendChild(script);
  };

  var main = function ($, baseJquery) {
    var jQuery = $;

    var Config = (function (storeConfig) {
      var config = $.extend({
        s3Prefix: '//s3.amazonaws.com/shopify-apps/wholesaleprices',
        cart_product_price: 'td [class=\'tt-price\']',
        cart_product_subtotal: '.CartItem__Price',
        cart_first_product_subtotal: '.CartItem__PriceList .CartItem__Price:first-of-type',
        cart_product_wrapper: '.CartItem__Wrapper',
        cart_subtotal: '#subtotal .value',
        cart_total: '#grandtotal .value',
        productPricesSelector: '.Price:not(.Price--compareAt):not(.CartItem__Price)',
        message_container: 'nav.main',
        productForm: 'form[action="/cart/add"]',
        addToCartEvent: 'click',
        addToCartButton: '[type=submit]',
        productContainer: 'body',
        variantSelect: '.single-option-selector',
        variantNativeSelect: '[name=id]',
        initTimeout: 0,
        insertAfter: '[data-order-summary-section="payment-lines"]',
        frameHeight: '500px',
        allowedCountries: ['US', 'BY', 'PT', 'PL'],
        customerVipTag: 'vip',
        customerWholesaleTag: 'wholesale',
        creditsInputSelector: '#vipStoreCreditsInput input[name="creditsValue"]',
        creditsMaxSelector: '#vipStoreCreditsInput input[name="creditsMax"]',

        customerVipRemovedTag: 'vip_removed',
        customerVipSubscriptionLabel: 'VIP subscription',
        customerVipSubscriptionCost: 29,
        orderUsedCreditsAttribute: 'Used VIP Credits',
        orderBalanceCreditsAttribute: 'Initial User VIP Balance',
        firstVipPricePostfix: ' VIP',
        disableAppParams: {
          'feed': 'google'
        },

        vipCheckoutPageUrl: '/pages/checkout',
        vipCartWidgetCheckoutText: 'Agree & Continue',
        cartForm: 'form[action="/cart"]',
        checkoutUrl: '/checkout',

        s3SharedPrefix: 'https://vip.madamglam.com/files/upload',
        apiUrl: 'https://vip.madamglam.com',
        draft_orders_api: 'https://vip.madamglam.com/files/upload/js/rest-proxy.js',
        debugString: '',
        vipProductVid: 22282723754042,
        vipFreeShipping: 2219651760186,
        excludeScripts: ['198803519']
      }, storeConfig);
      return {
        init: function () {
          config = $.extend(config, SWPMMSettings);
        },
        get: function (key, subset) {
          if (key && subset) {
            return config[subset][key];
          } else {
            return config[key] || null;
          }
        },
        set: function (key, value, subset) {
          subset = subset || false;
          if (key && subset) {
            return config[subset][key] = value;
          } else {
            return config[key] = value;
          }
        },
        getCartAttrName: function () {
          return this.get('cart_attr_name') ? this.get('cart_attr_name') : 'Member Prices';
        },
        getCartQuantitySelector: function (id) {
          var selector = Config.getCustom('cartQuantitySelector', '[id^=\'updates_:id\']');
          selector = (selector.indexOf(':id') !== -1) ? selector.replace(':id', id) : selector;

          return config['selector_prefix'] ? config['selector_prefix'] + selector : selector;
        },
        getCustom: function (key, defaultValue) {
          if (typeof (defaultValue) == 'undefined') {
            defaultValue = false;
          }

          return (typeof (SWPMMCustom) !== 'undefined' && typeof (SWPMMCustom[key]) !== 'undefined') ? SWPMMCustom[key] : defaultValue;
        },
        getZipcodeCookie: function () {
          return this.getCookie(config.zipcodeCookieName);
        },
        setZipcodeCookie: function (zipcode) {
          this.setCookie(config.zipcodeCookieName, zipcode);
        },
        setCookie: function (key, value, expirationInterval) {
          var expires = new Date();
          expirationInterval = expirationInterval || 10000 * 60 * 60 * 1000;// default = 1 hour
          expires.setTime(expires.getTime() + expirationInterval);
          document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
        },
        getCookie: function (key) {
          var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
          return keyValue ? keyValue[2] : null;
        },
        getHash: function () {
          if (Config.get('hash')) {
            return Config.get('hash');
          }
          return Config.get('id');
        }
      };
    })(SWPMMParams);

    $.fn.serializeObject = function () {
      // todo cm-591 refactoring this method for a separate class
      var self = this,
        json = {},
        push_counters = {},
        patterns = {
          'validate': /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
          'key': /[a-zA-Z0-9_]+|(?=\[\])/g,
          'push': /^$/,
          'fixed': /^\d+$/,
          'named': /^[a-zA-Z0-9_]+$/
        };

      this.build = function (base, key, value) {
        base[key] = value;
        return base;
      };

      this.push_counter = function (key) {
        if (push_counters[key] === undefined) {
          push_counters[key] = 0;
        }
        return push_counters[key]++;
      };

      $.each($(this).serializeArray(), function () {

        // Skip invalid keys
        if (!patterns.validate.test(this.name)) {
          return;
        }

        var k,
          keys = this.name.match(patterns.key),
          merge = this.value,
          reverse_key = this.name;

        while ((k = keys.pop()) !== undefined) {

          // Adjust reverse_key
          reverse_key = reverse_key.replace(new RegExp('\\[' + k + '\\]$'), '');

          // Push
          if (k.match(patterns.push)) {
            merge = self.build([], self.push_counter(reverse_key), merge);
          }

          // Fixed
          else if (k.match(patterns.fixed)) {
            merge = self.build([], k, merge);
          }

          // Named
          else if (k.match(patterns.named)) {
            merge = self.build({}, k, merge);
          }
        }

        json = $.extend(true, json, merge);
      });

      return json;
    };

    var App = function () {//base object
      var self = this;
      this.customer = {};
      this.custom_order = {};

      this.init = function () {
        Config.init();
        this.customer = SWPMMParams.customer;
        this.setOptions();
        // if (this.customer.id){
        //     if ( !this.isTaggedCustomer() ) {
        //         return false;
        //     }
        // }else{
        //     this.showMessage();
        // }
      };

      this.setOptions = function () {
        // setup options
        Spurit.prices.setOptions({
          format: Config.get('moneyFormat'),
          // for multicurrencies - not used yet
          // formats: {},
          // prefix: 'data',
          // selector: '#currencies'
        });
      };

      this.reloadPage = function () {
        location.reload(true);
      };

      this.getActiveTags = function () {
        var tags = [];
        if (SWPMMTags) {
          tags = Object.keys(SWPMMTags);
        }

        return tags;
      };

      this.getTagSettings = function () {
        if (this.customer.tags !== null && this.customer.tags.indexOf(Config.get('customerWholesaleTag')) !== -1)
          return SWPMMTags[Config.get('customerWholesaleTag')];

        return SWPMMTags[Config.get('customerVipTag')];
      };

      this.isTaggedCustomer = function () {
        // var membershipTags = this.getActiveTags();

        this.customer.tagSettings = this.getTagSettings();
        this.customer.isVipRemoved = this.isVipRemovedCustomer();
        // if (!this.customer.id){
        //     return true;
        // }

        // var tagsCount = this.customer.tags.length;
        // for (var i = 0; i<tagsCount; i++) {
        //     var customerTag = this.customer.tags[i];
        //     if ( membershipTags.indexOf(customerTag) > -1 ) {
        //         this.customer.tag = customerTag;
        //         this.customer.tagSettings = this.getTagSettings(customerTag);
        //         // this.showMessage();
        //         return true;
        //     }
        // }
        return true;
      };

      this.isVipCustomer = function () {
        if (!this.customer.id) {
          return false;
        }

        return this.customer.tags.indexOf(Config.get('customerVipTag')) > -1;
      };

      this.isWholesaleCustomer = function () {
        if (!this.customer.id) {
          return false;
        }

        return this.customer.tags.indexOf(Config.get('customerWholesaleTag')) > -1;
      };

      this.isVipRemovedCustomer = function () {
        if (!this.customer.id) {
          return false;
        }

        return this.customer.tags.indexOf(Config.get('customerVipRemovedTag')) > -1;
      };

      this.getVipStoreCredits = function () {
        let storeCredits = 0;
        self.customer.metafields.forEach(function (item) {
          if (item[0] === 'balance') {
            storeCredits = item[1] / 100;
          }
        });
        return storeCredits;
      };

      this.showMessage = function () {
        if ($('#SWPMM-message').length) {
          return;
        }
        var target = $(Config.get('message_container') + ':first');
        var position = Config.get('message_container_position');
        var enabled = false;
        if (this.customer.id) {
          var tagSettings = this.customer.tagSettings;

          var discount = (tagSettings.discount_type == 'fixed')
            ? Spurit.prices.formatMoney(tagSettings.discount * 100)
            : tagSettings.discount + '%';
          var name = this.customer.name;
          var type = ((tagSettings.products.constructor !== Array || tagSettings.collections.constructor !== Array) ? 'some' : 'all');
          var message = (type == 'some') ? Config.get('text_some_products') : Config.get('text_all_products');
          var color = (type == 'some') ? Config.get('color_some_products') : Config.get('color_all_products');
          enabled = (type == 'some') ? Config.get('enable_some_products') : Config.get('enable_all_products');
          message = message.replace(/:username/g, name);
          message = message.replace(/:discount_condition/g, discount);
        } else {
          var message = Config.get('text_not_registered');
          var color = Config.get('color_not_registered');
          enabled = Config.get('enable_not_registered');
        }

        if (target.length && parseInt(enabled)) {
          var messageBox = $('<div id="SWPMM-message" style="background-color: ' + color + '">' + message + '</div>');
          switch (position) {
            case 'after':
              target.after(messageBox);
              break;
            case 'before':
              target.before(messageBox);
              break;
            case 'inside':
              target.append(messageBox);
              break;

            default:
          }
        }
      };

      this.isProductTagged = function (product, collections) {
        // if (!this.customer.id) {
        //     return false;
        // }
        // var tagSettings = this.getTagSettings(Config.get('customerVipTag'));
        // if ( tagSettings.products.constructor === Array && tagSettings.collections.constructor === Array ) {
        //     return false;
        // }
        // var result = false;
        // result = this.isAllowedProduct(product);
        // if ( !result ) {
        //     result = this.isAllowedCollection(collections);
        // }

        // if (!this.isVipCollection(product.handle)) {
        //   return false;
        // }

        return this.isAllowedCollection(collections);
      };

      this.isAllowedProduct = function (product) {
        var tagSettings = this.getTagSettings(this.customer.tag);
        if (tagSettings.products.constructor !== Array) {
          if (tagSettings.products[product.id]) {
            var targetProduct = tagSettings.products[product.id];
            if (targetProduct.variants.indexOf('' + product.vid) > -1) {
              return true;
            }
          }
        }

        return false;
      };

      /**
       * @param productCollections array of collection objects
       */
      this.isAllowedCollection = function (productCollections) {
        var tagSettings = this.getTagSettings();
        if (tagSettings.collections.constructor !== Array) {
          var targetCategories = Object.keys(tagSettings.collections);

          var pcLength = productCollections.length;
          for (var i = 0; i < pcLength; i++) {
            var collection = productCollections[i];
            if (targetCategories.indexOf('' + collection.id) > -1) {
              return true;
            }
          }
        }

        return false;
      };

      /**
       *
       * @param product
       * @param element
       * @returns {$}
       */
      this.isBundleDiscount = function (product) {
        var res = product ? product.tags.includes('bundle-party') : $('.bundle-party').length;
        return res && $('*[data-discount-type="bundle-party"]').length;
      };

      /**
       *
       * @param cartItems
       * @returns {undefined}
       */
      this.getBundleDiscountSubtotal = function(cartItems) {
        var checkoutTotal = window.SWPMMParams.cartSubtotal;
        if(self.isBundleDiscount()) {
          var discountValue = 0;

          for(var id in cartItems) {
            if(cartItems.hasOwnProperty(id)) {
              for(var i = 0; i < SWPMMParams.items.length; i++) {
                if (id*1 === SWPMMParams.items[i].id*1 && self.isBundleDiscount(SWPMMParams.items[i].product)) {
                  discountValue += cartItems[id].discountValue;
                  break;
                }
              }
            }
          }
          checkoutTotal -= discountValue;
        }
        return checkoutTotal;
      }

      /**
       *
       * @param element
       * @returns {false}
       */
      this.isBundleDiscountProduct = function(element) {
        var parentElement = element.parentNode
        var elDataAttr = parentElement.closest('*[data-discount-type="bundle-party"]');
        return parentElement.classList.contains('bundle-party') && elDataAttr;
      }

      this.renewBundlePrice = function () {
        $('.bundle-party').each(function (index, element) {
          var price = $(element).find('.sp-price:visible .money').text();
          if (price) {
            var cPriceCont = $(element).find('.CartItem__Price:not(.sp-price)');
            cPriceCont.text(price);
            var currentPrice = parseInt(price.replace(/[^\d;]/g, '').trim());
            var originalPrice = parseInt($(element).attr('data-original'));
            if (currentPrice && originalPrice > currentPrice) {
              cPriceCont.after('<span class="CartItem__OriginalPrice Price Text--subdued Price--compareAt remove-with-reset">' + Spurit.prices.formatMoney(originalPrice) + '</span>');
              cPriceCont.addClass('Price--highlight');
            }
          }
        });
      };

      /**
       *
       * @param enabled
       */
      this.setBundleDiscountLoader = function (enabled) {
        if (this.isBundleDiscount()) {
          var node = $('#vipOrderLoading');
          enabled ? node.addClass('is-active') : node.removeClass('is-active');
        }
      };

      /**
       *
       * @param url
       * @returns {boolean}
       */
      this.renderBundleDiscounts = function (url) {
        if (!this.isBundleDiscount()) {
          return false;
        }

        var type = self.isVipCustomer() ? 'vip-price' : parseInt($('#cartVipWidget input:checked').val()) ? 'vip-price' : '';
        var addParams = this.AjaxAddProps(SWPMMParams.items[0], 0, type, this.discounted_lines);
        $.when(addParams).done(function () {
          self.getCheckoutData(url, true, function (res) {
            self.parseDiscounts(res, false);
            self.setBundleDiscountLoader(false);
          }, function (err) {
            console.error(err);
            self.setBundleDiscountLoader(false);
          });
        });
        return true;
      };

      /**
       *
       * @param callback
       * @returns {boolean}
       */
      this.refreshBundleDiscounts = function (callback) {
        if (!this.isBundleDiscount()) {
          return false;
        }
        if (typeof callback === 'undefined') {
          callback = function () {};
        }

        this.getCheckoutData('/checkout', true, function (res) {
          self.parseDiscounts(res, false);
          callback();
          self.setBundleDiscountLoader(false);
        }, function (err) {
          console.error(err);
          self.setBundleDiscountLoader(false);
        });
        return true;
      };

      /**
       *
       * @param enabled
       */
      this.renderBundleDiscountPrice = function (enabled) {
        if (this.isBundleDiscount()) {
          var node = $('.bundle-party');
          enabled ? node.removeClass('is-hidden') : node.addClass('is-hidden');
        }
      };

      /**
       *
       * @param type
       */
      this.reNewBundleDiscountProps = function (type) {
        if (this.isBundleDiscount()) {
          var callback = type ? function () {} : function () {
            Spurit.resetVipPrices();
            if (self.getVipStoreCredits() && !self.isContainGiftCardProduct) {
              self.showVipCreditsInput();
            }
          }
          var addParams = self.AjaxAddProps(SWPMMParams.items[0], 0, type, self.discounted_lines);
          $.when(addParams).done(function () {Spurit.refreshCart(callback);});
        }
      };

      /**
       *
       */
      this.redrawCommonDiscountPrices = function (isVip) {
        let $$priceTotals = $('.CartItem__Price:not(.sp-price):not(.Price--compareAt)');
        self.shopifyCart.items.forEach(function (item,index) {
          if ($$priceTotals.length < self.shopifyCart.items.length && $$priceTotals.length <= index) {
            //if autoadded element don't issue in list of items in DOM
            return;
          }
          if (item.discounts.length > 0) {
            let isAvailableForVip = false;
            item.discounts.forEach(function (discount) {
              if (self.isDiscountAvailable(discount.title)) {
                isAvailableForVip = true;
              }
            });
            if(!isAvailableForVip) {
              let totalPrice = isVip ? $$priceTotals[index].parentElement.dataset.original : $$priceTotals[index].parentElement.dataset.final;
              $$priceTotals[index].textContent = Shopify.formatMoney(totalPrice);
            }
          }
        });
      };

      /**
       *
       * @param items
       */
      this.excludeBundleVariants = function(items) {
        var tmp = [];

        if(self.isBundleDiscount() && items) {
          for (var id in items){
            if(items.hasOwnProperty(id)) {
              for(var i = 0; i < SWPMMParams.items.length; i++) {
                if (id*1 === SWPMMParams.items[i].id*1 && self.isBundleDiscount(SWPMMParams.items[i].product)) {
                  tmp.push(id*1);
                  break;
                }
              }
            }
          }
        }
        return tmp;
      }

      /**
       *
       * @param onSuccess
       * @param onError
       */
      this.forceClearCart = function (onSuccess, onError) {
        $.ajax({
          type: 'POST',
          url: '/cart/clear.js',
          success: function () {
            onSuccess();
          },
          error: function () {
            onError();
          },
          dataType: 'json'
        });
      };

      /**
       *
       * @param data
       * @param callback
       */
      this.forceAddDataToCart = function (data, callback) {
        $.ajax({
          type: 'POST',
          data: data,
          url: '/cart/add.js',
          success: function () {
            console.log('add product in cart');
            callback();
          },
          error: function () {
            console.log('fail add product in cart');
            callback();
          },
          dataType: 'json'
        });
      };

      /**
       *
       * @param name
       */
      this.delete_cookie = function (name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      };

      /**
       *
       */
      this.clearCartAfterLogout = function () {
        var excludeProperties = ['first', 'second', 'third', '_freeUS', 'shipping_boxes'];

        $('a[href="/account/logout"]').on('click', function (e) {
          e.preventDefault();

          $.getJSON('/cart.json').success(function (cart) {
            var cartItems = cart.items;

            if (cartItems.length) {
              var newCartItems = { items: [] };

              for (var i = 0; i < cartItems.length; i++) {
                var hasExcludeOption = false;
                for (var j = 0; j < excludeProperties.length; j++) {
                  if (cartItems[i].properties.hasOwnProperty(excludeProperties[j])) {
                    hasExcludeOption = true;
                    break;
                  }
                }
                if (!hasExcludeOption) {
                  newCartItems.items.push({
                    id: cartItems[i].variant_id,
                    quantity: cartItems[i].quantity
                  });
                }
              }
              self.forceClearCart(function () {
                self.delete_cookie('cart');
                if (newCartItems.items.length) {
                  self.forceAddDataToCart(newCartItems, function() {
                    window.location.replace('/account/logout');
                  });
                }
              }, function() {
                console.error('Cart not removed');
                window.location.replace('/account/logout');
              });
            } else {
              window.location.replace('/account/logout');
            }
          }).fail(function(){
            console.error('Bad request to cart.json');
            window.location.replace('/account/logout');
          });
        });
      };

      /**
       * Checks if product is included in at least
       * one collection in selected in App Settings (in VIP membership)
       * @returns {boolean}
       */
      this.isVipCollection = function (product_handle) {
        var tagSettings = this.customer.tagSettings;
        for (var key in tagSettings.collections) {
          if (typeof isIncludedInCollections === 'undefined') {
            var isIncludedInCollections = false;
          }
          if (
            tagSettings.collections.hasOwnProperty(key) &&
            typeof SWPMMParams.productsWithCollections[product_handle] !== 'undefined' &&
            SWPMMParams.productsWithCollections[product_handle].collections.includes(parseInt(key))
          ) {
            isIncludedInCollections = true;
            break;
          }
        }

        return typeof isIncludedInCollections === 'undefined' || isIncludedInCollections === true;
      };

      /**
       * Get product price from snippet
       *
       * @param product_handle
       * @returns bool | int
       */
      this.getProductPrice = function (product_handle) {
        if (!SWPMMParams.productsWithCollections.hasOwnProperty(product_handle)) {
          return false;
        }
        return SWPMMParams.productsWithCollections[product_handle].price;
      };

      /**
       *
       * @param product_handle
       * @returns bool
       */
      this.isFirstVipTag = function (product_handle) {
        if (!SWPMMParams.productsWithCollections.hasOwnProperty(product_handle)) {
          return false;
        }
        return SWPMMParams.productsWithCollections[product_handle].first_vip_tag;
      };

      this.getHandleFromUrl = function (url) {
        return /[^/]*$/.exec(url.split('?')[0])[0];
      };

      this.updatePrices = function () {
        Spurit.isDraftOrder = true;
        if ($(Config.get('cart_subtotal')).hasClass('sp-price')) {
          return false;
        }
        if (!Spurit.isDiscountApply) {
          if (self.getVipStoreCredits() && !self.isContainGiftCardProduct) {
            self.showVipCreditsInput();
          }
          Spurit.prices.recalculate('total', Config.get('cartSubtotal'), function () {
          });
          self.displayItemPrices();
        }
        Spurit.isDiscountApply = false;
      };

      this.resetPrices = function () {
        $('#vipDiscount').addClass('is-hidden');
        Spurit.isDraftOrder = false;
        let newCheckoutTotal = $('#subtotal .value').attr('data-newcheckouttotal');
        if (newCheckoutTotal !== undefined) {
          newCheckoutTotal = newCheckoutTotal.trim();
        } else {
          newCheckoutTotal = '0';
          $('#undefinedNewTotal').remove();
          $('#grandtotal').after('<div id="undefinedNewTotal" style="color: red">Some problem with calculate Total</div>');
          console.warn('Attribute newcheckouttotal = ', newCheckoutTotal);
        }
        var grandtotal = self.deleteMoneyFormat(newCheckoutTotal);
        if (typeof self.discount_to_subtotal !== 'undefined' && !isNaN(self.discount_to_subtotal)) {
          grandtotal -= self.discount_to_subtotal;
        }

        if(grandtotal) {
          var saveMoney = SWPMMParams.cartSubtotal - grandtotal;
          if (saveMoney) {
            var tmpMoney = '-' + Shopify.formatMoney(saveMoney);
            $('#zeroVipDiscount .value').text(tmpMoney);
            $('#zeroVipDiscount').removeClass('is-hidden');
          } else {
            $('#zeroVipDiscount').addClass('is-hidden');
          }
        }

        if (typeof Spurit.vipCreditsToUse !== 'undefined') {
          var inputVal = self.deleteMoneyFormat($(Config.get('creditsInputSelector')).val());
          grandtotal -= inputVal;
        }
        $('#grandtotal .value').text(Shopify.formatMoney(grandtotal));
        // if(!$('#cartVipWidget').length && $('#discountCode').hasClass('is-visible')) {
        //     $('#discountCode').removeClass('is-visible');
        // }

        if(self.isBundleDiscount()) {
          $('.remove-with-reset').each(function (index, element) {
            $(element).remove();
          });

          $('.bundle-party .CartItem__Price.Price--highlight:not(.sp-price)').each(function (index, element) {
            $(element).removeClass('Price--highlight');
          })
        }
        self.renewBundlePrice();

        var $$priceElements = $(Config.get('cart_product_price') + ', ' + Config.get('cart_product_subtotal') + ', ' + Config.get('cart_subtotal') + ', ' + Config.get('cart_total'));
        $$priceElements.each(function (index, element) {
          $(element).attr('style', '').siblings('.sp-price').remove();
        });
        if(!self.isBundleDiscount()) {
          $('.remove-with-reset').each(function (index, element) {
            $(element).remove();
          });
        }
        //hot fix for excludeScripts(don't show discount for line-item on VIP tab) and items without VIP prices.
        //show compareAt prices on PAYG tab
        if(Config.get('excludeScripts').indexOf(window.SWPMMParams.scriptId) !== -1) {
          $('.CartItem__OriginalPrice').attr('style','');
        }
      };

      this.calcNewPrice = function (price) {
        var tagSettings = self.customer.tagSettings;
        var discount = tagSettings.discount;
        var newPrice = price;

        // apply Vip Balance Discount

        if (discount && tagSettings.discount_type == 'percent') {
          newPrice = price - price * discount / 100;
        } else if (discount) {
          newPrice = (parseFloat(price) / 100 - discount) * 100;
        }
        if (newPrice < 0) {
          newPrice = price;
        } else {
          if (tagSettings.enabled_round && tagSettings.round_up) {
            newPrice = (Math.floor(parseFloat(newPrice) / 100) + '.' + tagSettings.round_up) * 100;
          }
        }

        return Math.ceil(newPrice);
      };

      this.calcNewFirstPrice = function (price) {
        var tagSettings = self.customer.tagSettings;
        var discount = parseFloat(tagSettings.first_discount);
        var newPrice = price;

        // apply Vip Balance Discount

        if (discount && tagSettings.first_discount_type == 'percent') {
          newPrice = price - price * discount / 100;
        } else if (discount) {
          newPrice = (discount > parseFloat(price) / 100) ? parseFloat(price) / 100 : discount;
          newPrice *= 100;
        }
        if (newPrice < 0) {
          newPrice = price;
        } else {
          if (tagSettings.enabled_round && tagSettings.round_up) {
            newPrice = (Math.floor(parseFloat(newPrice) / 100) + '.' + tagSettings.round_up) * 100;
          }
        }

        return Math.ceil(newPrice);
      };

      this.setStyle = function (el, name, val) {
        if (el.style[name] !== undefined) {
          el.setAttribute('data-initial-style-' + name, el.style[name]);
        }
        if (val.indexOf('!important') === -1) {
          el.style[name] = val;
        } else {
          el.style.cssText += ';' + name + ':' + val;
        }
      };
      //don't touch this, ever!
      this.getCheckoutItem = function (html) {
        var productId, variantId, quantity, oldPrice, newPrice, discountValue, discount, oldPriceString, newPriceString,
          discountsLines, firstNewPrice, firstQuantity;
        var discountCode = $(html).find('.order-summary__section .tags-list .reduction-code__text').text();
        var checkoutItems = $(html).find('table tr[class="product"]');
        var parseArray = [];
        checkoutItems.each(function () {
          discountValue = 0;
          firstNewPrice = -1; //newprice for 1-st line-item auto-discount product
          firstQuantity = 0;
          productId = $(this).data('productId');
          variantId = $(this).data('variantId');
          discountsLines = $(this).find('.reduction-code .reduction-code__text');
          if (typeof parseArray[variantId] !== 'undefined') {
            firstNewPrice = parseArray[variantId].newPrice;
            firstQuantity = parseArray[variantId].quantity;
          }

          oldPriceString = $(this).find('td[class="product__price"] del').text().trim();
          newPriceString = $(this).find('td[class="product__price"] .order-summary__emphasis').text().trim();
          newPrice = newPriceString === 'Free' ? 0 : self.deleteMoneyFormat(newPriceString);
          quantity = $(this).find('.product-thumbnail__quantity').text().trim();
          oldPrice = oldPriceString ? self.deleteMoneyFormat(oldPriceString) : newPrice;
          discountValue += self.discountValue(discountsLines, discountCode,2);
          discount = discountValue / oldPrice;
          parseArray[variantId] = {
            'productId': productId,
            'variantId': variantId,
            'oldPrice': oldPrice,
            'newPrice': newPrice,
            'quantity': parseInt(quantity),
            'discount': discount,
            'discountValue': discountValue,
            'firstNewPrice': firstNewPrice,
            'firstQuantity': firstQuantity
          };
        });
        return parseArray;
      };
      //calculate discount for line-item without discount code/only with discount code
      this.discountValue = function (discountsLines, code, without = true) {
        var discountValue = 0;
        var allDiscountValue = 0;
        discountsLines.each(function () {
          var line = $(this).text();
          var arr = line.split('(').map(function (item) {
            return item.trim();
          });
          allDiscountValue += self.deleteMoneyFormat(arr[1]);
          if (arr[0] !== code && without) {
            if (self.isDiscountAvailable(arr[0])) {
              if (typeof (without) === 'number') {
                discountValue = allDiscountValue;
              } else {
                discountValue += self.deleteMoneyFormat(arr[1]);
              }
            }
          }
          if (arr[0] === code && !without) {
            discountValue += self.deleteMoneyFormat(arr[1]);
          }
        });
        return discountValue;
      };

      //get only fixed amount discounts
      this.getAvailableCartDiscount = function (html) {
        var cartDiscountElement = $(html).find('.order-summary__section .total-line--reduction[data-discount-type="fixed_amount"]');
        var cartDiscount = {};
        if (cartDiscountElement.length) {
          cartDiscount = {
            code: cartDiscountElement[0].querySelector('.reduction-code__text').textContent,
            amount: cartDiscountElement[0].querySelector('[data-checkout-discount-amount-target]').dataset.checkoutDiscountAmountTarget
          }
        }
        return cartDiscount;
      }

      this.isDiscountAvailable = function (code) {
        code = code.toUpperCase();
        var result = false;
        if (SWPMMDiscounts) {
          if (SWPMMDiscounts.indexOf(code) != -1) {
            result = true;
          }
        }
        return result;
      };

      this.getCheckoutData = function (url, async, onSuccess, onError) {
        if (typeof async === 'undefined') {
          async = false;
        }
        if (typeof onSuccess === 'undefined') {
          onSuccess = function () {};
        }
        if (typeof onError === 'undefined') {
          onError = function () {};
        }
        var checkoutUrl = url;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', checkoutUrl, async);

        xhr.onload = function (e) {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              onSuccess(xhr.responseText);
            } else {
              onError(xhr.statusText);
            }
          }
        };

        xhr.onerror = function (e) {
          onError(xhr.statusText);
        };

        xhr.send();
        return xhr.responseText;
      };

      this.deleteMoneyFormat = function (price) {
        return parseInt(parseFloat(price.replace(/[\$,\-\(\)]/g, '') * 100).toFixed());
      };

      this.checkVipShippingIs = function (hasToBeAdded, callback = () => {
      }) {
        callback();
        return true;
        if (typeof hasToBeAdded === 'undefined') {
          hasToBeAdded = true;
        }
        $.ajax({
          type: 'GET',
          url: '/cart.json',
          success: function (data) {
            self.callbackCheckVipShippingIs(hasToBeAdded, data, callback);
          },
          dataType: 'json'
        });
      };

      this.callbackCheckVipShippingIs = function (hasToBeAdded, data, callback = () => {
      }) {
        
        var numOfVipFreeShippingProducts = 0,
          vipProductVid = Config.get('vipProductVid'),
          actionUrl = '',
          actionData = { 'id': vipProductVid };

        data.items.every(function (item) {
          if (typeof item.variant_id === 'undefined' || item.variant_id !== vipProductVid) {
            return true;
          }
          numOfVipFreeShippingProducts++;
          return true;
        });

        if (!hasToBeAdded) {
          if (numOfVipFreeShippingProducts > 0) {
            // remove VIP product
            actionUrl = '/cart/change.js';
            actionData.quantity = 0;
          }
        } else {
          if (numOfVipFreeShippingProducts === 0) {
            // add VIP product
            actionUrl = '/cart/add.js';
          } else if (numOfVipFreeShippingProducts > 1) {
            // set only one VIP product
            actionUrl = '/cart/change.js';
            actionData.quantity = 1;
          }
        }

        if (actionUrl) {
          try {
            $.ajax({
              type: 'POST', url: actionUrl,
              data: actionData, async: false, dataType: 'json',
              success: function () {
                callback();
              },
              error: function (xhr, ajaxOptions, thrownError) {
                callback();
              },
            });
          } catch (e) {
            callback();
          }
        } else {
          callback();
        }
      };

      this.loadingStart = function (clickElement) {
        if (clickElement) {
          $(clickElement).prop('disabled', true);
        }
        $('body').addClass('no-scroll');
        $('#vipOrderLoading').addClass('is-active');
      };

      this.loadingEnd = function (clickElement) {
        $('body').removeClass('no-scroll');
        $('#vipOrderLoading').removeClass('is-active');
        if (clickElement) {
          $(clickElement).prop('disabled', false);
        }
      };

      this.checkGoogleFeed = function () {
        let searchStr = this.parseUrlQuery();
        for (let prop in Config.get('disableAppParams')) {
          if(searchStr.hasOwnProperty(prop)) {
            document.cookie = 'disable_vip_app=1; Path=/;';
          }
        }
      }

      this.parseUrlQuery = function () {
        var data = {};
        if(location.search) {
          var pair = (location.search.substring(1)).split('&');
          for(var i = 0; i < pair.length; i ++) {
            var param = pair[i].split('=');
            data[param[0]] = param[1];
          }
        }
        return data;
      }

      this.checkGoogleFeed = function () {
        let searchStr = this.parseUrlQuery();
        for (let prop in Config.get('disableAppParams')) {
          if(searchStr.hasOwnProperty(prop)) {
            document.cookie = 'disable_vip_app=1; Path=/;';
          }
        }
      }

      this.parseUrlQuery = function () {
        var data = {};
        if(location.search) {
          var pair = (location.search.substring(1)).split('&');
          for(var i = 0; i < pair.length; i ++) {
            var param = pair[i].split('=');
            data[param[0]] = param[1];
          }
        }
        return data;
      }

      Spurit.showAlert = function (text) {
        $('body').addClass('no-scroll')
          .append('<div class="popup is-visible"><div class="popup-content">' + text + '<a href="#" class="close-style"><span></span></a></div></div>');
      };

      Spurit.hideAlert = function () {
        $('body.no-scroll').removeClass('no-scroll');
        $('.popup.is-visible').removeClass('is-visible');
      };

      $(document).keyup(function (event) {
        //check if user has pressed 'Esc'
        if (event.which === 27) {
          Spurit.hideAlert();
        }
      });

      $('body').on('click', '.popup', function (e) {
        e.preventDefault();
        if ($(e.target).is('.popup')) {
          Spurit.hideAlert();
        }
      }).on('click', '.close-style', function (e) {
        e.preventDefault();
        Spurit.hideAlert();
      });
    };


    var pausePage = function () {
      var self = this;
      this.chargeDate = null;
      this.customer = {};
      this.mainAction = '';
      this.pathToAction = [];
      this.isPause = false;
      this.config = {
        selectors: {
          mainMenuBlock: '.manage-my-membership__main-menu',
          pauseBlock: '.manage-my-membership__pause',
          resultBlock: '.manage-my-membership__result',
          feedbackBlock: '.manage-my-membership__feedback',
          perksBlock: '.manage-my-membership__perk-page',
          cancelCouponBlock: '.manage-my-membership__cancel-coupon',
          cancelBlock: '.manage-my-membership__cancel',
          pauseInput: '[id^="pause_menu_item"]',
          mainMenuInput: '[id^="Main_menu_item"]',
          cancelInput: '[id^="reason_cancel"]',
          currentBLock: '.manage-my-membership__block:not(.hide)',
          showCancelCheckbox: '#show-cancel',
          cancelOptions: '.manage-my-membership__cancel-items'
        },
        ids: {
          pauseButton: 'pause-button',
          resumeButton: 'resume-button',
          mainMenuButton: 'main-menu-button',
          continueCancelButton: 'continue-cancel-button',
          cancelButton: 'cancel-button',
          claimOfferButton: 'claim-offer',
          campaignSettings: 'google-utm-settings',
          backLink: 'back-from-membership'
        }
      };
      App.apply(this, arguments);//inherit app constructor
      Config.init();
      var customerId = SWPMMParams.customer.id;
      if (!customerId)
        throw new Error('Customer ID can not be empty');

      this.init = function () {
        
        this.apiUrl = Config.get('apiUrl');
        this.pauseButton = document.getElementById(this.config.ids.pauseButton);
        this.resumeButton = document.getElementById(this.config.ids.resumeButton);
        this.mainMenuButton = document.getElementById(this.config.ids.mainMenuButton);
        this.continueCancelButton = document.getElementById(this.config.ids.continueCancelButton);
        this.cancelButton = document.getElementById(this.config.ids.cancelButton);
        this.claimOfferButton = document.getElementById(this.config.ids.claimOfferButton);
        this.campaignSettings = document.getElementById(this.config.ids.campaignSettings);
        this.mainMenuBlock = document.querySelector(this.config.selectors.mainMenuBlock);
        this.pauseBlock = document.querySelector(this.config.selectors.pauseBlock);
        this.resultBlock = document.querySelector(this.config.selectors.resultBlock);
        this.feedbackBlock = document.querySelector(this.config.selectors.feedbackBlock);
        this.perksBlock = document.querySelector(this.config.selectors.perksBlock);
        this.cancelBlock = document.querySelector(this.config.selectors.cancelBlock);
        this.cancelCouponBlock = document.querySelector(this.config.selectors.cancelCouponBlock);
        this.cancelOptions = document.querySelector(this.config.selectors.cancelOptions);
        this.backLink = document.getElementById(this.config.ids.backLink);

        this.customer = {
          id: customerId,
          email: SWPMMParams.customer.email,
          firstName: SWPMMParams.customer.first_name,
          lastName: SWPMMParams.customer.first_name
        };
        let pauseItems = document.querySelectorAll(this.config.selectors.pauseInput),
          mainMenuItems = document.querySelectorAll(this.config.selectors.mainMenuInput),
          cancelInputs = document.querySelectorAll(this.config.selectors.cancelInput),
          showCancel = document.querySelector(this.config.selectors.showCancelCheckbox);
        pauseItems.forEach(function (input) {
          input.addEventListener('click', self.pauseInputHandler);
        });
        mainMenuItems.forEach(function (input) {
          input.addEventListener('click', self.activateMainMenuButton);
        });
        cancelInputs.forEach(function (input) {
          input.addEventListener('click', self.cancelInputHandler);
        });
        showCancel.addEventListener('change', self.showCancelButton);
        this.pauseButton.addEventListener('click', this.pauseHandler);
        this.resumeButton.addEventListener('click', this.resumeHandler);
        this.mainMenuButton.addEventListener('click', this.mainMenuHandler);
        this.continueCancelButton.addEventListener('click', this.continueCancelHandler);
        this.cancelButton.addEventListener('click', this.cancelHandler);
        if (this.claimOfferButton) {
          this.claimOfferButton.addEventListener('click', this.claimOfferHandler);
        }
        self.isPause = !this.resultBlock.classList.contains('hide');
        window.onhashchange = this.hashHandler;
        if (__st.p) {
          $('body').addClass('no-scroll');
          $('#vipOrderLoading').addClass('is-active');
        }
        $(window).on('load', function () {
          $('#back-from-membership,#mobile-back-from-membership').on('click', function (e) {
            history.back();
          });
        });
        this.loadingEnd();
        this.hashHandler();
      };

      this.hashHandler = function (event) {
        let hash = window.location.hash.substr(1);
        let currentBlock = document.querySelector(self.config.selectors.currentBLock);
        currentBlock.classList.add('hide');
        self.backLink.querySelector('span').innerHTML = '< Previous Page';
        switch (hash) {
          case 'pause':
            self.pauseBlock.classList.remove('hide');
            break;
          case 'pauseCancel':
            self.pauseBlock.classList.remove('hide');
            self.pauseBlock.querySelector('[href="#cancel"]').classList.remove('hide');
            self.pathToAction.push('Pause membership');
            break;
          case 'feedback':
            self.feedbackBlock.classList.remove('hide');
            break;
          case 'perk':
            self.perksBlock.classList.remove('hide');
            self.pathToAction.push('Perks Reminder');
            break;
          case 'cancel':
            self.cancelCouponBlock.classList.remove('hide');
            break;
          case 'cancelOption':
            self.shuffleList(self.cancelOptions);
            self.cancelBlock.classList.remove('hide');
            break;
          default:
            self.backLink.querySelector('span').innerHTML = '< Back to My Account';
            if (self.isPause) {
              self.resultBlock.classList.remove('hide');
            } else {
              self.mainMenuBlock.classList.remove('hide');
            }
        }
        window.scrollTo(0, 0);
      };

      this.shuffleList = function (list) {
        for (let i = list.children.length; i >= 0; i--) {
          list.appendChild(list.children[Math.random() * i | 0]);
        }
      };

      this.getCampaignSettings = function () {
        return {
          'utm_source': this.campaignSettings.dataset.source,
          'utm_medium': this.campaignSettings.dataset.medium,
          'utm_name': this.campaignSettings.dataset.name
        };
      };

      this.getUrlWithUtmCodes = function (url, content) {
        let settingsAtributes = '';
        let campaignSettings = this.getCampaignSettings();
        for (let key in campaignSettings) {
          let separator = settingsAtributes ? '&' : '';
          settingsAtributes += separator + key + '=' + campaignSettings[key];
        }
        return url + '?' + settingsAtributes + '&utm_content=' + content;
      };

      this.formatPath = function (pathToAction) {
        return pathToAction.map(function (item, index) {
          return index + 1 + '.' + item;
        });
      };

      this.getPathString = function () {
        return this.formatPath(self.pathToAction).toString();
      };

      this.activateMainMenuButton = function (event) {
        self.mainMenuButton.removeAttribute('disabled');
        self.mainMenuButton.dataset.redirect = this.dataset.redirect;
        self.mainAction = this.dataset.type;
      };

      this.pauseInputHandler = function (event) {
        self.pauseButton.removeAttribute('disabled');
        self.pauseButton.dataset.pause = event.target.value;
      };

      this.cancelInputHandler = function (event) {
        self.continueCancelButton.removeAttribute('disabled');
        self.continueCancelButton.dataset.redirect = this.dataset.redirect;
        self.continueCancelButton.dataset.type = this.dataset.type;
        self.continueCancelButton.dataset.title = this.dataset.title;
      };

      this.continueCancelHandler = function (event) {
        window.location.href = this.dataset.redirect;
        self.pathToAction.push(this.dataset.title);
        if (this.dataset.type === 'redirect') {
          self.loadingStart();
        }
      };

      this.cancelHandler = function (event) {
        self.pathToAction.push('Cancel');
        let targetElement = this;
        self.loadingStart(targetElement);
        let pathToAction = self.getPathString();
        let request = {
          customer: self.customer,
          pathToAction: pathToAction
        };
        $.ajax({
          url: self.apiUrl + '/checkout/unsubscribe',
          dataType: 'json',
          type: 'post',
          headers: {
            'X-Store-Hash': Config.getHash()
          },
          contentType: 'application/json',
          data: JSON.stringify(request),
          processData: false,
          success: function (data, textStatus, jQxhr) {
            window.location.href = self.getUrlWithUtmCodes('/account#cancelSubscription', pathToAction);
          },
          error: function (jqXHR, exception) {
            Spurit.showAlert(jqXHR.responseJSON.error);
            self.loadingEnd(targetElement);
          }
        });
      };

      this.showCancelButton = function () {
        if (this.checked) {
          self.cancelButton.classList.remove('hide');
        } else {
          self.cancelButton.classList.add('hide');
        }
      };

      this.claimOfferHandler = function (event) {
        let targetElement = this;
        self.pathToAction.push('Claim offer');
        self.loadingStart(targetElement);
        let pathToAction = self.getPathString();
        let request = {
          customer: self.customer,
          pathToAction: pathToAction
        };
        $.ajax({
          url: self.apiUrl + '/checkout/claimOffer',
          dataType: 'json',
          type: 'post',
          headers: {
            'X-Store-Hash': Config.getHash()
          },
          contentType: 'application/json',
          data: JSON.stringify(request),
          processData: false,
          success: function (data, textStatus, jQxhr) {
            window.location.href = self.getUrlWithUtmCodes('/account#claimOffer', pathToAction);
          },
          error: function (jqXHR, exception) {
            Spurit.showAlert(jqXHR.responseJSON.error);
            self.loadingEnd(targetElement);
          }
        });
      };

      this.mainMenuHandler = function () {
        window.location.href = this.dataset.redirect;
        if (this.dataset.type === 'redirect') {
          self.loadingStart();
        }
      };

      this.resumeHandler = function (event) {
        let targetElement = this;
        self.pathToAction.length = 0;
        self.loadingStart(targetElement);
        let request = {
          customer: self.customer
        };
        $.ajax({
          url: self.apiUrl + '/checkout/resumePause',
          dataType: 'json',
          type: 'post',
          headers: {
            'X-Store-Hash': Config.getHash()
          },
          contentType: 'application/json',
          data: JSON.stringify(request),
          processData: false,
          success: function (data, textStatus, jQxhr) {
            self.loadingEnd(targetElement);
            window.location.href = '/account#resumePause';
          },
          error: function (jqXHR, exception) {
            Spurit.showAlert(jqXHR.responseJSON.error);
            self.loadingEnd(targetElement);
          }
        });
      };

      this.pauseHandler = function (event) {
        let targetElement = this;
        self.loadingStart(targetElement);
        self.pathToAction.push('Pause');
        let pause = parseInt(event.target.dataset.pause);
        let pathToAction = self.getPathString();
        self.setChargeDate(pause);
        let request = {
          customer: self.customer,
          pause: pause,
          chargeDate: self.chargeDate,
          pathToAction: pathToAction
        };
        $.ajax({
          url: self.apiUrl + '/checkout/pauseSubscription',
          dataType: 'json',
          type: 'post',
          headers: {
            'X-Store-Hash': Config.getHash()
          },
          contentType: 'application/json',
          data: JSON.stringify(request),
          processData: false,
          success: function (data, textStatus, jQxhr) {
            history.replaceState(null, '', '/account');
            window.location.href = self.getUrlWithUtmCodes('/pages/manage-my-membership', pathToAction);
          },
          error: function (jqXHR, exception) {
            self.loadingEnd(targetElement);
            Spurit.showAlert(jqXHR.responseJSON.error);
          }
        });
      };

      this.setResultData = function (data) {
        let countMonthStr = data.pausePeriods === 1 ? ' month' : ' months';
        this.resultBlock.querySelector('h2 > span').innerHTML = ' ' + data.pausePeriods + ' ' + countMonthStr;
        this.resultBlock.querySelector('h2 + p').innerHTML = this.resultBlock.querySelector('h2 + p').innerHTML + ' ' + data.endPause;
      };

      this.setChargeDate = function (pause) {
        let currentDate = new Date();
        let chargeDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + pause + 1, 1);
        let chargeMonth = chargeDate.toLocaleString('en-EN', { month: 'long', day: 'numeric' });
        self.chargeDate = chargeMonth;
      };
    };

    var editCustomer = function () {
      var self = this;
      Config.init();
      this.getInterestArray = function (object) {
        var arr = [];
        for (const prop in object) {
          if (prop.indexOf('interest_') + 1)
            arr[arr.length] = object[prop];
        }
        return arr;
      };

      this.convertPhoneNumber = function (customer) {
        console.log(customer);
        let phone = customer.phone;
        if (customer.country === 'Canada' || customer.country === 'United States') {
          if (/\+1/.exec(phone)) {

          } else if (/^1/.exec(phone)) {
            phone = '+' + phone;
          } else {
            phone = '+1' + phone;
          }
        }
        return phone;
      };

      var $form = $('#update-customer-form');
      if (!$form.length)
        throw new Error('Container was not found');
      $form.on('submit', function (event) {
        event.preventDefault();
        var _learnq = window._learnq || [];
        var formData = $(event.target).serializeObject();
        formData.customer.phone = Spurit.iti.getNumber();
        var apiUrl = Config.get('apiUrl');
        var interestArray = self.getInterestArray(formData.customer.note);
        $.ajax({
          type: 'POST',
          url: apiUrl + '/checkout/editCustomer',
          headers: {
            'X-Store-Hash': Config.getHash()
          },
          data: JSON.stringify(formData),
          processData: false,
          success: function (e) {
            _learnq.push(['identify', {
              '$email': formData.customer.static_email,
              '$phone_number': formData.customer.phone,
              '$Date Of Birth': formData.customer.note.date_of_birth,
              '$Interest in': interestArray
            }]);
            window.location.href = '/account?view=confirm-update';
          },
          error: function (xhr, ajaxOptions, thrownError) {
            Spurit.showAlert(xhr.responseJSON.error);
          },
          dataType: 'json',
          contentType: 'application/json'
        });
      });
    };

    var cardDetailsPage = function () {
      Config.init();
      var customerId = SWPMMParams.customer.id;
      if (!customerId)
        throw new Error('Customer ID can not be empty');

      var $form = $('#update-card-details-form');
      if (!$form.length)
        throw new Error('Container was not found');

      loadScript('https://js.braintreegateway.com/web/dropin/1.22.0/js/dropin.min.js', function () {
        var apiUrl = Config.get('apiUrl');
        var debugString = Config.get('debugString') || '';
        $.ajax({
          url: apiUrl + '/checkout/token' + debugString,
          dataType: 'json',
          headers: { 'X-Store-Hash': Config.getHash() },
          success: function (res) {
            if (!res.token)
              return Spurit.showAlert('Error: Payment gateway token was not received');

            braintree.dropin.create({
              authorization: res.token,
              selector: '#bt-dropin',
              card: {
                overrides: {
                  styles: {
                    '#credit-card-number::placeholder': {
                      'font-size': '24px'
                    },
                    '#cvv::placeholder': {
                      'font-size': '24px'
                    }
                  }
                }
              }
            }, function (createErr, instance) {
              if (createErr)
                return Spurit.showAlert('Error: Payment gateway was not initialized properly');

              $form.on('submit', function (event) {
                event.preventDefault();
                $('#update-card-details-form [type="submit"]').prop('disabled', true);
                instance.requestPaymentMethod(function (err, payload) {
                  if (err) {
                    return Spurit.showAlert('Error: Credit card validation failed' + err.message);
                    $('#update-card-details-form [type="submit"]').prop('disabled', false);
                  }
                  var request = {
                    nonce: payload.nonce,
                    customer: {
                      id: customerId,
                      email: SWPMMParams.customer.email,
                      firstName: SWPMMParams.customer.first_name,
                      lastName: SWPMMParams.customer.first_name
                    }
                  };
                  $.ajax({
                    url: apiUrl + '/checkout/updateCardDetails' + debugString,
                    dataType: 'json',
                    type: 'post',
                    headers: {
                      'X-Store-Hash': Config.getHash()
                    },
                    contentType: 'application/json',
                    data: JSON.stringify(request),
                    processData: false,
                    success: function (data, textStatus, jQxhr) {
                      window.location.href = '/account/?view=confirm-card-update';
                    },
                    error: function () {
                      Spurit.showAlert('Credit card information was not updated');
                      $('#update-card-details-form [type="submit"]').prop('disabled', false);
                    }
                  });
                });
              });
            });
          }
        });
      });
    };


    var currentPage = (function () {
      var pageName = null;
      if (__st.p) {
        pageName = __st.p;
      } else {
        if (window.location.hostname == 'checkout.shopify.com' || window.location.pathname.indexOf('/orders/') !== -1) {
          pageName = 'checkout';
        } else if (window.location.pathname.indexOf('/cart') === 0) {
          pageName = 'cart';
        }
      }
      if (window.location.pathname.indexOf('/pages/card-details') !== -1 || window.location.search.indexOf('?view=my-cards') !== -1 || window.location.search.indexOf('?view=subscribe') !== -1) {
        pageName = 'card';
      } else if (window.location.pathname.indexOf('/pages/manage-my-membership') === 0) {
        pageName = 'pause';
      } else if (window.location.pathname.indexOf('/account') === 0 && window.location.search.indexOf('?view=edit-information') !== -1) {
        pageName = 'edit-customer';
      }
      if (window.location.pathname.indexOf('/pages/checkout') !== -1) {
        pageName = 'custom';
      }

      return pageName;
    })();

    var initApp = function () {
      //var priceUpdaterObj = new priceUpdater();
      var appObj = new App();
      appObj.checkGoogleFeed();
      switch (currentPage) {
/*
        case 'product':
          new ProductPage().init();
          Config.set('firstVipPricePostfix',' First VIP Gel');
          priceUpdaterObj.init();
          break;
        case 'cart':
          Config.set('firstVipPricePostfix',' First VIP Gel');
          new CartPage().init();
          break;
        */  
        case 'card':
          cardDetailsPage();
          break;
        case 'pause':
          new pausePage().init();
          break;
        case 'edit-customer':
          new editCustomer();
          break;
        /*  
        default:
          appObj.init();
          priceUpdaterObj.init();
          Spurit.recalculatePrices = function () {
            priceUpdaterObj.init();
          };
        */ 
      }

      /*
      if (window.location.pathname === Config.get('vipCheckoutPageUrl')) {
        window.setShippingRates = function (data) {
          window.shippingRates = data;

          var vipIt = 0;
          var vipInt = setInterval(function () {
            if (++vipIt > 100) {
              clearInterval(vipInt);
            }
            if ($('#shipping-rates input').length) {
              clearInterval(vipInt);

              $('body').on('change', $('#shipping-rates input'), function () {
                var shippingRate = window.shippingRates[$('#shipping-rates input:checked').data('i')];
                if (typeof shippingRate === 'undefined') {
                  //Spurit.showAlert('Shipping method is a required field');
                  return false;
                }
                $('#cartShippingValue').html(shippingRate.price);
                window.vipPriceChanged();
              });

              $('#shipping-rates input').trigger('change');
            }
          }, 50);
        };
        new VipCheckoutPage().init();
      }
      */
    };

    /*
    var pathToScriptPrices = Config.get('s3SharedPrefix') + '/js/spurit.prices.min.js';
    var linkScript = document.querySelector('#spurit-prices');
    if (linkScript) {
      pathToScriptPrices = linkScript.getAttribute('href');
    }
    */

    
    loadScript(Config.get('folderStore') + Config.get('id') + '.js?' + Math.random(), function () {
      //loadScript(Config.get('s3Prefix') + '/js/jquery.spur.cart.api.js', function(){// Including api.jquery.js
      //loadScript(pathToScriptPrices, function () {
        loadScript(Config.get('s3SharedPrefix') + '/js/spurit.checkout.min.js', function () {
          initApp();
        });
      //});
      
      //});
    });
  };

  // Selector Picker
  if (document.location.search.indexOf(selectorPicker.cmd) !== -1) {
    var AjaxCart = (function () {//responsible for Shopify Cart API calls

      return {
        post: function (url, data, callback) {
          $.ajax({
            type: 'POST',
            url: url,
            cache: false,
            dataType: 'json',
            data: data
          }).done(function (data) {
            if (typeof callback === 'function') callback(data);
          }).fail(function (err) {
            try {
              var desc = JSON.parse(err.responseText).description;
              if (desc.length) {
                app.loader(false);
                alert(desc);
              }
            } catch (e) {
            }
          });
        },
        addItem: function (itemData, callback) {
          AjaxCart.post('/cart/add.js', itemData, function (data) {
            if (typeof callback === 'function') callback(data);
          });
        },
        clear: function (callback) {
          AjaxCart.post('/cart/clear.js', {}, function (data) {
            if (typeof callback === 'function') callback(data);
          });
        }
      };
    })();

    loadScript(selectorPicker.url, function () {
      if (typeof (SWPMMParams.items) !== 'undefined') {
        var getParams = window.location.search.replace('?', '').split('&').reduce(
          function (p, e) {
            var a = e.split('=');
            p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
            return p;
          },
          {}
        );
        if (typeof (getParams.vid) !== 'undefined' && SWPMMParams.items.length != 1) {
          AjaxCart.clear(function () {
            AjaxCart.addItem({ 'quantity': 1, 'id': getParams.vid }, function () {
              document.location.reload();
            });
          });
        }
      }
    });
    return;
  }

  try {
    if ((typeof jQuery === 'undefined') || (versionCompare('2.0', jQuery.fn.jquery))) {
      var doNoConflict = true;
      if (typeof jQuery === 'undefined') {
        doNoConflict = false;
      }
      loadScript('//ajax.googleapis.com/ajax/libs/jquery/2.1.4/jquery.min.js', function () {
        if (doNoConflict) {
          jQuery17 = jQuery.noConflict(true);
        } else {
          jQuery17 = jQuery;
        }
        main(jQuery17, jQuery);
      });
    } else {
      main(jQuery, jQuery);
    }
  } catch (e) {
    console.log('Wholesale Prices Membership Manager app exception: ' + e);
  }

})();
